/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolShieldIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-shield"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 22.73Q12 22.73 11.9 22.73Q11.8 22.73 11.6 22.69Q11.4 22.65 11.2 22.6Q7.55 21.45 5.4 18.14Q3.25 14.82 3.25 11.1L3.25 6.28Q3.25 5.45 3.73 4.78Q4.2 4.1 4.97 3.8L11.07 1.5Q11.53 1.32 12 1.32Q12.47 1.32 12.93 1.5L19.02 3.8Q19.8 4.1 20.27 4.78Q20.75 5.45 20.75 6.28L20.75 11.1Q20.75 14.82 18.6 18.14Q16.45 21.45 12.8 22.6Q12.6 22.65 12.4 22.69Q12.2 22.73 12 22.73Z" fill={color} />
    </svg>
  );
}
